import { combineReducers } from 'redux';
import globalReducer from './global';
import faqReducer from './faq';

const reducer = combineReducers({
    globalReducer,
    faqReducer
});

export default reducer;
